export const BILLING_ROUTES = {
  summary: {
    get: '/billing/summary',
  },
  history: {
    get: '/billing/history',
  },
  schedules: {
    get: '/billing/schedules',
  },
  portalSession: {
    post: '/billing/portal-session',
  },
  activationPreview: {
    get: '/billing/job-responses/{responseId}/activation-preview',
  },
  listingActivationPreview: {
    get: '/billing/listings/{listingType}/{listingId}/activation-preview',
  },
  adminCredits: {
    get: '/billing/admin/employers/{employerId}/credits',
    post: '/billing/admin/employers/{employerId}/credits',
  },
  adminCredit: {
    delete: '/billing/admin/credits/{creditId}',
  },
};
